<div class="faq">
    <div class="container">
    <h3 class="faq__title">Preguntas frecuentes</h3>
    <div class="faq__container">
      <div class="faq__item" *ngFor="let item of faqItems; let i = index" [class.active]="activeIndex === i">
        <div class="faq__question" (click)="toggleFaq(i)">
          <h4>{{ item.question }}</h4>
          <i class="bi" [ngClass]="activeIndex === i ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        </div>
        <div class="faq__answer">
          <p>{{ item.answer }}</p>
        </div>
      </div>
    </div>
    </div>
  </div>